export { iconMap } from "./icon-map";
export type { IconName } from "./icon-map";
